// extracted by mini-css-extract-plugin
export default {"InvoiceComp":"Invoice_InvoiceComp__tbx9x","fw-bold":"Invoice_fw-bold__7Id5A","total-price":"Invoice_total-price__lAvbZ","thank-you":"Invoice_thank-you__PbkI1"};